import { Options, Vue } from 'vue-class-component';
import { mapState } from 'vuex';
import { EMPTY_GUID, RiserFloorsApartments } from '@/core/utils/EntrancePlant/entrance-plant.utils';
import { PropType } from '@vue/runtime-dom';
import { AddressingType, EntrancePlantDetailDTO } from '@/../client-generator/generated-clients/plants';

@Options({
  name: 'RiserItem',
  props: {
    riserStructure: {
      type: Object as PropType<RiserFloorsApartments>,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  emits: ['riser-selected'],
})
export default class RiserItem extends Vue {
  riserStructure!: RiserFloorsApartments;
  currentEntrancePlant!: EntrancePlantDetailDTO;

  get floorsApartmentCount() {
    const parts: string[] = [];

    if (this.currentEntrancePlant.addressingType == AddressingType.BuildingRiserFloorApartment) {
      const riserFloorsLength = new Set(
        (this.riserStructure.interfaceTabs ?? [])
          .flatMap(col => col.floors ?? [])
          .map(({ floor }) => floor.floorId)
          .filter((floorId): floorId is string => !!floorId && floorId !== EMPTY_GUID)
      ).size;
      if (riserFloorsLength > 0) parts.push(`${riserFloorsLength} ${this.$t('AppResourceEP.Floors')}`);
    }

    const riserApartmentsLength = this.riserStructure.interfaceTabs?.reduce((acc, col) => acc + col.floors.reduce((floorAcc, floor) => floorAcc + (floor.apartments?.length ?? 0), 0), 0) ?? 0;
    if (riserApartmentsLength > 0) parts.push(`${riserApartmentsLength} ${this.$t('AppResourceEP.Apartments')}`);

    return parts.length > 0 ? parts.join(' ') : this.$t('AppResource.Empty');
  }
}
